import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Endpoints } from '@/http/endpoints';
import { http } from '@/http/http';
import { useClientStore } from '@/client/client-store';

interface UserProfile {
  roleNames?: string[];
}

export const USER_ROLES_STALE_TIME_MS = 5 * 60_000;

export function rumRolesForProfileQueryKey(clientId: string) {
  return ['rumRolesForProfile', clientId] as const;
}

export async function fetchRumRolesForProfile(clientId: string): Promise<string[]> {
  const res = await http<UserProfile[]>(Endpoints.rumRolesForProfile(clientId));
  return res[0]?.roleNames ?? [];
}

export function rumRolesForProfileQueryOptions(clientId: string) {
  return {
    queryKey: rumRolesForProfileQueryKey(clientId),
    queryFn: () => fetchRumRolesForProfile(clientId),
    staleTime: USER_ROLES_STALE_TIME_MS,
  };
}

export function usePrefetchUserRoles(): void {
  const currentClientId = useClientStore((s) => s.current?.id);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!currentClientId) return;
    void queryClient.prefetchQuery(rumRolesForProfileQueryOptions(currentClientId));
  }, [currentClientId, queryClient]);
}
